(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("printful-size-guide")) {
  customElements.define(
    "printful-size-guide",
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll("[data-sg-tab]");
        this.panels = this.querySelectorAll("[data-sg-panel]");
        this.unitButtons = this.querySelectorAll("[data-sg-unit]");
        this.tables = this.querySelectorAll("[data-sg-table]");
        this.tabs.forEach((button) => {
          button.addEventListener("click", () => this.selectTab(button.dataset.sgTab));
        });
        this.unitButtons.forEach((button) => {
          button.addEventListener("click", () => this.selectUnit(button.dataset.sgUnit));
        });
      }
      selectTab(key) {
        this.tabs.forEach((button) => {
          button.setAttribute("aria-selected", String(button.dataset.sgTab === key));
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.sgPanel !== key;
        });
      }
      selectUnit(unit) {
        this.unitButtons.forEach((button) => {
          button.setAttribute("aria-pressed", String(button.dataset.sgUnit === unit));
        });
        this.tables.forEach((table) => {
          table.hidden = table.dataset.sgTable !== unit;
        });
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

})();
